import { useParams } from "react-router-dom";
import Single from "../../components/Directories/Single";
import ViewItem from "../../components/Templates/ViewItem";
import useDirectoryContainer from "../../containers/Directories/useDirectoryContainer";
import { useContent } from "../../content/useContent";

import { Routes } from "../../routes/Routes";

const Directory: React.FC = () => {
  const { directoryId } = useParams();

  const {
    directory,
    pageLoading,

    handleDelete,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  } = useDirectoryContainer(directoryId);

  const { directories } = useContent().pages;

  return (
    <ViewItem
      name={directories.title}
      pageLoading={pageLoading}
      item={directory}
      editPath={Routes.getEditDirectory(directoryId)}
      handleDelete={handleDelete}
      openDeleteDialog={openDeleteDialog}
      setOpenDeleteDialog={setOpenDeleteDialog}
      deleteLoading={loading}
      itemRef="name"
      Card={<Single directory={directory} />}
    />
  );
};

export default Directory;
